import { render, staticRenderFns } from "./office-hours-edit.vue?vue&type=template&id=68d6a860&scoped=true&lang=pug"
import script from "./office-hours-edit.vue?vue&type=script&lang=ts"
export * from "./office-hours-edit.vue?vue&type=script&lang=ts"
import style0 from "./office-hours-edit.vue?vue&type=style&index=0&id=68d6a860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6a860",
  null
  
)

export default component.exports